import React, { useCallback } from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
import { RoundIconButton } from "../../atoms";
import { ArrowRight } from "../../icons";
export var CarouselArrows = function(param) {
    var canGoBack = param.canGoBack, canGoForward = param.canGoForward, onPrev = param.onPrev, onNext = param.onNext, className = param.className;
    var handlePrevClick = useCallback(function() {
        onPrev();
    }, [
        onPrev
    ]);
    var handleNextClick = useCallback(function() {
        onNext();
    }, [
        onNext
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge(cx("flex justify-center items-center", className))
    }, /*#__PURE__*/ React.createElement(RoundIconButton, {
        "aria-label": "Previous",
        disabled: canGoBack === false,
        className: "mr-3 rotate-180",
        onClick: handlePrevClick
    }, /*#__PURE__*/ React.createElement(ArrowRight, {
        className: "shrink-0"
    })), /*#__PURE__*/ React.createElement(RoundIconButton, {
        "aria-label": "Next",
        disabled: canGoForward === false,
        className: "ml-3",
        onClick: handleNextClick
    }, /*#__PURE__*/ React.createElement(ArrowRight, {
        className: "shrink-0"
    })));
};

//# sourceMappingURL=CarouselArrows.js.map